import $ from 'jquery';

$(function () {
  var $select = $('.js-question-select');

  if (!$select.length) {
    return;
  }

  var initFunction = function () {
    var $toHide = $('.js-question-options');
    var $toShow = $('.js-question-options[data-qid="' + $select.val() + '"]');
    $toHide.addClass('hidden').find('input').prop('disabled', true);
    $toShow.removeClass('hidden').find('input').prop('disabled', false);
  };

  $select.change(function (e) {
    initFunction();
    window.StreamObject.asyncPageUpdate();
  });

  initFunction();
});
